import { render, staticRenderFns } from "./MarqetaEditUser.vue?vue&type=template&id=525fc022&scoped=true"
import script from "./MarqetaEditUser.vue?vue&type=script&lang=js"
export * from "./MarqetaEditUser.vue?vue&type=script&lang=js"
import style0 from "./MarqetaEditUser.vue?vue&type=style&index=0&id=525fc022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525fc022",
  null
  
)

export default component.exports